export const BUSINESS = {
    brand: "Finance Wealth",
    domain: "financewealth.com.au",
    broker: "Gurpreet Singh",
    role: "Mortgage Broker",
    credentials: "Diploma (Finance & Mortgage Broking) · BCom (Accounting & Finance)",
    phone: "0493 659 554",
    phoneTel: "+61493659554",
    email: "gurpreet@financewealth.com.au",
    addressLine1: "Office 4444, Ground Floor",
    addressLine2: "470 St Kilda Road",
    addressLine3: "Melbourne VIC 3004",
    addressFull: "Office 4444, Ground Floor, 470 St Kilda Road, Melbourne VIC 3004",
    // Legal / Compliance details
    companyName: "Gurpreet A Singh Pty. Limited",
    companyAbn: "72 642 964 341",
    creditRepName: "Gurpreet Singh",
    creditRepNumber: "548489",
    corporateCreditRepName: "Gurpreet A Singh Pty. Limited",
    corporateCreditRepNumber: "560697",
    aclHolder: "Brass Aggregation Pty Ltd",
    aclNumber: "561247",
    disclaimer:
        "Your complete financial situation will need to be assessed before acceptance of any proposal or product."
};

export const COMPLIANCE_LINE_SHORT =
    "Gurpreet Singh is an authorised Credit Representative No. 548489 of Brass Aggregation Pty Ltd Australian Credit Licence No. 561247. Company Gurpreet A Singh Pty. Limited ABN 72 642 964 341 has been appointed as Corporate Credit Representative No. 560697";

export const SERVICES = [
    { slug: "home-loans", title: "Home Loans", desc: "Tailored home loan solutions for owner-occupiers — competitive rates from 60+ lenders.", icon: "Home" },
    { slug: "first-home-buyer", title: "First Home Buyer", desc: "Step-by-step guidance, grants & schemes to get you into your first home.", icon: "KeyRound" },
    { slug: "refinance", title: "Refinance", desc: "Lower repayments, unlock equity, or restructure your existing loan.", icon: "Repeat" },
    { slug: "investment-loans", title: "Investment Loans", desc: "Build a property portfolio with structures that suit your wealth strategy.", icon: "TrendingUp" },
    { slug: "commercial-loans", title: "Commercial Loans", desc: "Funding for business premises, working capital and commercial property.", icon: "Building2" },
    { slug: "self-employed", title: "Self-Employed Loans", desc: "Alt-doc and full-doc loans for business owners and sole traders.", icon: "Briefcase" },
    { slug: "car-loans", title: "Car & Asset Finance", desc: "Competitive vehicle and equipment finance for personal or business.", icon: "Car" },
    { slug: "personal-loans", title: "Personal Loans", desc: "Short-term financing to consolidate debt or fund life moments.", icon: "Wallet" }
];

export const LENDERS = [
    "CBA", "Westpac", "ANZ", "NAB", "Macquarie", "ING", "St.George",
    "Bankwest", "Suncorp", "AMP", "Pepper", "Liberty", "La Trobe", "Resimac",
    "Bank of Melbourne", "BankSA", "Heritage", "Bendigo Bank", "ME Bank"
];

export const TESTIMONIALS = [
    {
        title: "Seamless from start to settlement",
        body: "Gurpreet helped us secure finance for our first home. He explained every step, found us a rate well below what our bank offered, and was available whenever we had questions.",
        author: "Priya & Daniel R.",
        location: "VIC"
    },
    {
        title: "Saved us $480/month on our mortgage",
        body: "We were stuck on a high variable rate. Within two weeks of speaking with Gurpreet our refinance was approved with a top-tier lender and we are saving thousands a year.",
        author: "Michael T.",
        location: "VIC"
    },
    {
        title: "Made self-employed finance simple",
        body: "As a contractor I had been knocked back twice. Gurpreet structured my application properly, used the right lender, and we settled on a beautiful property.",
        author: "Anastasia K.",
        location: "VIC"
    },
    {
        title: "Honest, transparent and patient",
        body: "What stood out was the honesty — no pressure, no jargon. Gurpreet looked at the full picture and recommended what was right for us, not what paid him most.",
        author: "Hardeep & Simran S.",
        location: "VIC"
    }
];

export const STATS = [
    { value: "$420M+", label: "Loans settled" },
    { value: "60+", label: "Lenders on panel" },
    { value: "98%", label: "Approval rate" },
    { value: "1,200+", label: "Happy clients" }
];
